import { CustomerData, CustomerSchemeSummary } from '../customers';
import { ProductSegment, ProductVariants } from '../products';
import { Location } from '../cfa';

export enum ProductSelectorType {
  SPECIFIC_PRODUCTS = 'SPECIFIC_PRODUCTS',
  ALL_PRODUCTS = 'ALL_PRODUCTS',
  DIVISIONS = 'DIVISIONS',
  CATEGORIES = 'CATEGORIES',
}

export enum TriggerCondition {
  AT_CART = 'AT_CART',
  USER_PREFERENCE_AT_CHECKOUT = 'USER_PREFERENCE_AT_CHECKOUT',
}

export interface CreateSchemeDiscountRequest {
  workspaceId: string;
  name: string;
  enabled: boolean;
  startsAt: string;
  endsAt: string;
  skus?: string[];
  stateCodes: any[];
  customerCodes?: any[];
  promotionCode: string;
  productSelectorType: ProductSelectorType;
  triggerCondition: TriggerCondition;
  productSelectorIds?: string[];
  categoryIds?: string[];
  cfaDivisionCodes?: CreateSchemeDiscountCfaDivisionCode[];
  slabs: CreateSchemeDiscountSlab[];
}

export interface CreateSchemeDiscountCfaDivisionCode {
  cfaCode: string;
  divisionCode: string;
}

export interface CreateSchemeDiscountSlab {
  minimumQty: number;
  maximumQty: number;
  discountPercentage: number;
  entity: string;
}

export interface CreateBuyXGetYRequest {
  workspaceId: string;
  name: string;
  enabled: boolean;
  startsAt: string;
  endsAt: string;
  promotionCode: string;
  cfaDivisionCodes: CfaDivisionCode[];
  stateCodes: any[];
  customerCodes: any[];
  slabs: CreateBuyXGetYSlab[];
}

export interface CfaDivisionCode {
  cfaCode: string;
  divisionCode: string;
}

export interface CreateBuyXGetYSlab {
  qtyXFrom: string;
  qtyXTo: string;
  qtyY: string;
  type: string;
  SkusX: string[];
  SkusY: string[];
}

export interface ConditionsActions {
  code: string;
  args: ConditionsActionsArgs[];
}

export interface ConditionsActionsArgs {
  name: string;
  value: null[] | string;
}

export interface SchemesRequest {
  pageNo?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
  promotionType?: string;
  includeProducts?: boolean;
  startDate?: string | Date;
  endDate?: string | Date;
  skuCode?: string;
  status?: string;
  schemeCode?: string;
  searchKey?: string;
  includeCFA?: boolean;
  triggerCondition?: TriggerCondition;
  dispatchFilters?: boolean;
  body?: {
    cfaFilter?: string[];
    divisionFilter?: string[];
  };
}

export interface Schemes {
  promotions: Scheme[];
  division: SchemeDivision[];
  cfa: SchemeCfa[];
  cfas: SchemeCfa[];
  totalRecords: number;
  startRecord: number;
  endRecord: number;
}

export interface SchemeCfa {
  id: string;
  createdDate: string;
  updatedDate: string;
  fulfillmentLocationCode: string;
  physicalAddress: any;
  supplierName: string;
  fulfillmentAddress?: string;
  GSTNumber: string;
  businessPan: string;
  postalCode?: string;
  isActive: boolean;
  workspaceId: string;
  stateId?: string;
  country?: string;
  cityId: any;
  phone: any;
  //state?: State;
}
export interface SchemeDivision {
  id: string;
  createdDate: string;
  updatedDate: string;
  name: string;
  code: string;
  workspaceId: string;
  isDefault: boolean;
  isActive: boolean;
  headDivisionId?: string;
  stateId?: string;
  divisionId?: string;
}

export interface SchemeProduct {
  sku: string;
  name: string;
  price: number;
  MRP: number;
  PTR: number;
  id: number;
  packsize: number;
  minOrderQty: number;
  maxOrderQty: number;
  qtyMultiplier: number;
  assetUrl: string;
  segments: ProductSegment[];
  facets?: {
    facetName: string;
    facetValue: string;
    facetValueCode: string;
  }[];
}

export interface SelectedScheme {
  id: number;
  code: string;
}

export interface Scheme {
  startsAt: string;
  endsAt: string;
  couponCode: any;
  perCustomerUsageLimit: any;
  name: string;
  enabled: boolean;
  promotionCode: string | null;
  promotionType: string;
  skusX: string;
  skusY: string;
  pts: number;
  upc: string;
  division: {
    id: string;
    name: string;
    code: string;
  }[];
  category: { id: string; name: string }[];
  discountPercentage: number;
  discountPercentageUpto: number;
  sku: string;
  baseUom?: string;
  variantIdsX: string;
  variantIdsY: string;
  id: number;
  qtyX?: string;
  qtyY?: string;
  minimumQty: number;
  product?: SchemeProduct;
  productVariantIds?: string;
  title: string;
  productSelectorItems: {
    id: string;
    name: string;
  }[];
  qtyXFrom?: string;
  qtyXTo?: string;
  cfaDetails?: SchemeCfa[];
  maximumQty: number;
  slabs: Slab[];
  packSize: number;
  ptr: number;
  mrp: number;
  triggerCondition: TriggerCondition;
  productInCart: number;
  cfaResponse?: { code: string; id: string; name: string }[];
  productSelectorType: ProductSelectorType;
  divisionResponse?: {
    divisionCode: string;
    divisionId: string;
    name: string;
    headDivisionId: string;
    headDivision: {
      id: string;
      code: string;
      name: string;
    };
  }[];
  customerCodes?: string[];
}

export interface SchemeCfaData {
  cfaCode: string;
  cfaId: string;
  supplierName: string;
  minOrderQty: number;
}

export interface Schemes {
  promotions: Scheme[];
  totalRecords: number;
  startRecord: number;
  endRecord: number;
}

export interface CreateSchemeInputs {
  name: string;
  startsAt: string;
  endsAt: string;
  minimumQty?: string;
  discountPercentage?: number;
  skus?: string[];
  qtyX?: string;
  qtyY?: string;
  SkusX?: string[];
  SkusY?: string[];
  promotionCode: string;
}
interface schemeCustomerDetails {
  companyName: string;
  customerCode: string;
  mobileNo: string;
}

export interface GetScheme {
  productVariantId: number;
  selectedOrder: ProductVariants;
  startsAt: string;
  endsAt: string;
  couponCode: null;
  perCustomerUsageLimit: string | null;
  name: string;
  enabled: boolean;
  promotionType: null | string;
  sku: string;
  variantIdsX?: Array<number | null>;
  variantIdsY?: Array<number | null>;
  qtyX?: string;
  qtyY?: string;
  id: number;
  minimumQty?: number | string;
  productSelectorItems: {
    id: string;
    name: string;
  }[];
  productSelectorType: ProductSelectorType;
  discountPercentage?: number;
  promotionCode: string | null;
  packSize: number;
  baseUom: string | null;
  boxQty: string;
  pts: number | string;
  ptr: number;
  mrp: number | string | null;
  upc: any;
  category?: string;
  segments?: ProductSegment[];
  maximumQty: number | string;
  freeQty?: string;
  cfaDetails: SchemeCfaData[];
  schemeMinQty: number;
  schemeMaxQty: number;
  isExclusive: boolean;
  productImageLink?: string;
  customersRes: schemeCustomerDetails[];
  schemeappliedStatus: string;
  slabs: Slab[];
  triggerCondition?: TriggerCondition;
}

type FreeProductNames =
  | 'qtyXFrom'
  | 'qtyXTo'
  | 'type'
  | 'variantIdsX'
  | 'qtyY'
  | 'variantIdsY'
  | 'entity';

type DiscountNames =
  | 'minimumQty'
  | 'maximumQty'
  | 'productVariantIds'
  | 'entity'
  | 'discount'
  | 'stateCodes'
  | 'customerCodes';

export interface Slab {
  code: string;
  args: {
    name: FreeProductNames | DiscountNames;
    value: number | string;
  }[];
}
export interface FetchSchemesParams {
  principalWorkspaceId: string;
  params: {
    customerId?: string;
    pageNo: number;
    pageSize: number;
    skuCode: string;
    sortDirection: string;
    sortBy: string;
    startDate: string;
    endDate: string;
    dispatchFilters: boolean;
    body: {
      cfaFilter: string[];
      divisionFilter: string[];
    };
  };
}
export interface FetchSchemesSearchParams {
  principalWorkspaceId: string;
  params: {
    pageNo: number;
    pageSize: number;
    searchKey: string;
  };
}

export interface CreateSchemeInitialState {
  schemeName: string;
  schemeCode: string;
  schemeType: string;
  slabs: {
    minOrderQuantity: number[] | null[];
    maxOrderQuantity: number[] | null[];
    freeProduct: number[] | null[];
    discountPercentage: number[] | null[];
  };
  startDate: any;
  endDate: any;
  startTime: any;
  endTime: any;
  applySchemeFor: string;
  isSpecific: boolean;
  cfas: Location[];
  customers: CustomerSchemeSummary[];
  stateCodes: any[];
}

export interface CreateTrailSchemeRequest {
  workspaceId: string;
}

export interface CreateTrailSchemeResponse {}

export enum SchemeActionButtons {
  RULEINFO = 'rule info',
  CONDITIONS = 'conditions',
  ACTIONS = 'actions',
  CONTENT = 'content',
}

export enum SchemeTypes {
  BUYXGETY = 'buy_x_get_y_free',
  PRODUCTDISCOUNT = 'products_percentage_discount',
}

export interface UpdateTurnoverInvoiceStatusRequest {
  invoiceId: string;
  sellerWorkspaceId: string;
  status: 'APPROVED' | 'REJECTED';
  remarks: string;
}

export interface UpdateTurnoverInvoiceStatusResponse {
  success: boolean;
  message?: string;
}

export interface BulkUpdateTurnoverInvoiceStatusRequest {
  invoiceIds: string[];
  sellerWorkspaceId: string;
  status: 'APPROVED' | 'REJECTED';
  remarks: string;
}

export interface BulkUpdateTurnoverInvoiceStatusResponse {
  success: boolean;
  message?: string;
  data?: {
    total: number;
    successCount: number;
    failureCount: number;
    results: {
      invoiceId: string;
      success: boolean;
      requestedStatus: string;
      message: string;
    }[];
  };
}

export interface UpdateTurnoverSchemeSortOrderItem {
  id: string;
  sortOrder: number;
}

export interface UpdateTurnoverSchemeSortOrderRequest {
  sellerWorkspaceId: string;
  schemes: UpdateTurnoverSchemeSortOrderItem[];
}

export interface UpdateTurnoverSchemeSortOrderResponse {
  success: boolean;
  message?: string;
}

export interface GetTurnoverInvoiceActivityLogsRequest {
  invoiceId: string;
  sellerWorkspaceId: string;
}

export interface TurnoverInvoiceActivityLogItem {
  id: string;
  invoiceId: string;
  action: string;
  title: string;
  message: string;
  changedBy: string;
  createdAt: string;
}

export interface TurnoverInvoiceActivityLogResponse {
  success: boolean;
  data: TurnoverInvoiceActivityLogItem[];
}

export interface EvaluateTurnoverInvoiceRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    invoiceId?: string;
    invoiceNumber?: string;
  };
}

export interface EvaluateTurnoverInvoiceResponse {}

export interface RemapCustomerProductRequest {
  sellerWorkspaceId: string;
  invoiceId: string;
  cfaId: string;
  invoiceLineId: string;
  productName: string;
  productVariantId: number;
  skuCode: string;
  mappedProductName: string;
  mappedSkuCode: string;
}

export interface RemapCustomerProductResponse {
  success: boolean;
  message?: string;
}

export type SchemeStep = 'details' | 'products' | 'slabs' | 'publish';

export type MultipleSchemeType = 'freeProduct' | 'discount';

export interface BulkCreateBuyXGetYSchemeRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: CreateBuyXGetYRequest[];
}

export interface BulkCreateBuyXGetYSchemeResponse {}

export interface BulkCreateProductDiscountSchemeRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: CreateSchemeDiscountRequest[];
}

export interface BulkCreateProductDiscountSchemeRespone {}

export type SchemeStatus = 'EXPIRED' | 'COMING_SOON' | 'ACTIVE' | 'INACTIVE';

export type SchemeType = 'buy_x_get_y_free' | 'product_discount';

export interface SchemesFiltersResponse {
  statuses: SchemeStatus[];
  schemeTypes: SchemeType[];
  cfas: { id: string; name: string }[];
  divisions: { id: string; name: string }[];
  customers: { id: string; name: string }[];
  categories: { id: string; name: string }[];
}
